import * as ng from 'angular';
import './login.scss';
import uiRouter from '@uirouter/angularjs';
import { LoginComponent } from './login.component';
import { ActivationErrorModalComponent } from './activation-error-modal/activation-error-modal.component';
import { ActivationMailSentModalComponent } from './activation-mail-sent-modal/activation-mail-sent-modal.component';
import { RecoverPasswordModalComponent } from './recover-password-modal/recover-password-modal.component';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('login', {
            url: '/login',
            data: {
                authorisationLevel: 0,
                pageTitle: 'Log In'
            },
            'views': {
                'multiContent': {
                    template: '<login flex="100"></login>'
                }
            }
        }
        );
};

stateConfig.$inject = ['$stateProvider'];

export const LoginModule: string = ng
    .module('archiSmall.login', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('login', LoginComponent)
    .component('activationErrorModalComponent', ActivationErrorModalComponent)
    .component('activationMailSentModalComponent', ActivationMailSentModalComponent)
    .component('recoverPasswordModalComponent', RecoverPasswordModalComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/login/login.module.ts